<app-item-form
  [formGroup]="formGroup"
  [overallImages]="overallImages"
  [noseImages]="noseImages"
  [tailImages]="tailImages"
  (classificationSelect)="onClassificationSelect($event)"
  (imagesAdd)="onItemImageAdd($event)"
  (imagesDelete)="onItemImageDelete($event)"
  [deleteable]="true"
  [showLocation]="true"
></app-item-form>